import { initialErrorState } from "views/common";

export function isValid() {
  const errors = initialErrorState();
  errors.entity = [];
  return errors;
}
